import React from "react";

import { Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

import { FileRepoIcon } from "../../../File-repository/Table/FileRepoIcon";

export const FileNameCell: React.FC<{ fileType: string; fileName: string; onClick?: () => void }> = ({
  fileType,
  fileName,
  onClick
}) => (
  <Stack
    flexDirection="row"
    gap="5px"
    alignItems="center"
    onClick={onClick}
    sx={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      cursor: onClick ? "pointer" : "default"
    }}
  >
    <FileRepoIcon type={fileType} sx={{ fill: "#26a6ae" }} />
    <MaterialTooltip title={fileName}>
      <Typography
        noWrap
        sx={{
          display: "block",
          color: "#26a6ae",
          "&:hover": onClick ? { textShadow: "0.3px 0 0 #26a6ae" } : undefined
        }}
      >
        {fileName}
      </Typography>
    </MaterialTooltip>
  </Stack>
);
